import Header from './Components/Header/Header';
import Hero from './Components/Hero/Hero';
import './App.css';
import Experience from './Components/Experience/Experience';
import Research from './Components/Research/Research';
import Achievements from './Components/Achievements/Achievements';
import Footer from './Components/Footer/Footer';


function App() {
  return (
    <>
      <Header />
      <Hero />
      <Experience/>
      <Research />
      <Achievements/>  
      <Footer/>    
    </>

  );
}

export default App;
